"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _index = require("./index");
var _memoize = _interopRequireDefault(require("../helpers/memoize"));
var createArgumentedSelector = function createArgumentedSelector() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  var recomputations = 0;
  var memoizedFn = (0, _memoize.default)(function (props) {
    var selector = _index.createSelector.apply(void 0, fns);
    recomputations += 1;
    return function (state) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      return selector.apply(void 0, [state, props].concat(args));
    };
  });
  var wrappedSelector = function wrappedSelector(state, props) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }
    return memoizedFn(props).apply(void 0, [state].concat(args));
  };
  wrappedSelector.recomputations = function () {
    return recomputations;
  };
  wrappedSelector.resetRecomputations = function () {
    recomputations = 0;
  };
  return wrappedSelector;
};
var _default = exports.default = createArgumentedSelector;